import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { subscribePreviewRefresh } from '../lib/previewBus';

const LivePreview = () => {
  const { t } = useTranslation();
  const iframeRef = useRef(null);

  const refreshPreview = () => {
    if (iframeRef.current) {
      const url = new URL(iframeRef.current.src);
      iframeRef.current.src = url.pathname + url.search;
    }
  };

  useEffect(() => subscribePreviewRefresh(refreshPreview), []);

  return (
    <div className="live-preview-container">
      <div className="preview-header">
        <h4>{t('dashboard.preview')}</h4>
        <button onClick={refreshPreview} className="btn-refresh">
          <RefreshCw size={15} strokeWidth={2} />
          {t('dashboard.preview')}
        </button>
      </div>
      <div className="preview-frame">
        <iframe
          ref={iframeRef}
          src="/"
          title="Website Preview"
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: 'none' }}
        />
      </div>
    </div>
  );
};

export default LivePreview;
